import React from 'react';
import { CircularProgress, Fab, Tooltip, withStyles } from '@material-ui/core';
import { Check as CheckIcon } from '@material-ui/icons';
import PropTypes from 'prop-types';
import Translator from 'translator';

function SaveButton({ disabled, classes, onClick, loading }) {
    const renderButton = () => {
        return (
            <Fab
                style={{
                    maxHeight: 30,
                    minHeight: 30,
                    minWidth: 30,
                    maxWidth: 30,
                }}
                disabled={disabled}
                aria-label={Translator.translate('general.save')}
                size="small"
                onClick={onClick}
                className={classes.saveIcon}
            >
                <CheckIcon className={classes.icon} />
            </Fab>
        );
    };

    if (loading) {
        return (
            <CircularProgress
                style={{
                    maxHeight: 30,
                    minHeight: 30,
                    minWidth: 30,
                    maxWidth: 30,
                }}
            />
        );
    }
    if (disabled) {
        return <div className={classes.container} />;
    }
    return (
        <Tooltip title={Translator.translate('general.save')} placement="top">
            {renderButton()}
        </Tooltip>
    );
}
const styles = theme => ({
    container: {
        maxHeight: 30,
        minHeight: 30,
        minWidth: 30,
        maxWidth: 30,
    },
    saveIcon: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
});

SaveButton.propTypes = {
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
};
SaveButton.defaultProps = {
    disabled: false,
    loading: false,
};

export default withStyles(styles, { withTheme: true })(SaveButton);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/Product/Fhe/SDM19INL/components/SaveButton.js